import { render, staticRenderFns } from "./EditVersionCliente.vue?vue&type=template&id=18c91141"
import script from "./EditVersionCliente.vue?vue&type=script&lang=js"
export * from "./EditVersionCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports